import React, { useEffect, useState } from 'react'
import NormalizeMedia from '../../utils/NormalizeMedia'

import {
  StyledButton,
  StyledCard,
  StyledIcon,
  StyledInfos,
  StyledInfosImage,
  StyledMedia,
  StyledSubtitle,
  StyledSubtitleContainer,
  StyledSubtitleVideo,
  StyledTitle,
  StyledTitleContainer,
} from './MediaCard.styled'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import { getCloudinaryImageAttachment } from '../../utils/getCloudinaryImageAttachment'
import MediaTypeEnum from '../../enums/MediaType'
import CKEditorContent from '../CKEditorContent/CKEditorContent'
import { StyledText } from '../CardModal/CardModal.styled'

const BASE_URL = 'https://res.cloudinary.com/constellium/image/upload'

const MediaCard = ({
  image,
  description,
  onChange,
  openMedia,
  id,
  activeId,
  titleLevel1,
  titleLevel2,
}) => {
  const [isActive, setIsActive] = useState(false);
  const toggleActive = () => onChange(id)

  let downloadUrl = null


  useEffect(() => {
    setIsActive(activeId === id);
  }, [activeId, id])


  if((image?.cloudinaryAsset && image?.cloudinaryAsset[0]?.resource_type !==  MediaTypeEnum.image)|| image?.youtubeUrl ) {
    const hasThumbnail = image?.cloudinaryPosterVideo || image?.videoThumbnail

    return (
      <StyledCard onClick={toggleActive} $isSelected={isActive}>
        <StyledMedia onClick={openMedia}>{NormalizeMedia(image, false, true, hasThumbnail)}</StyledMedia>
        <StyledInfos>
          <StyledTitleContainer>
            <StyledTitle>{titleLevel1}</StyledTitle>
            {titleLevel2 && (<StyledSubtitleVideo>{titleLevel2}</StyledSubtitleVideo>)}
          </StyledTitleContainer>
          {description &&
             <StyledText>
              <CKEditorContent html={description} />
            </StyledText>}
        </StyledInfos>
      </StyledCard>
    )
  } else {

    const isCloudinaryImage = image?.cloudinaryAsset && image?.cloudinaryAsset.length > 0
    const isContentfulImage = image?.contentfulAsset && image?.contentfulAsset.gatsbyImageData

    downloadUrl = isCloudinaryImage
      ? getCloudinaryImageAttachment(BASE_URL, image?.cloudinaryAsset[0].format, image?.name, image?.cloudinaryAsset[0].public_id)
      : (isContentfulImage)
        ? image?.contentfulAsset.gatsbyImageData.images.fallback?.src
        : null

    return (
      <StyledCard onClick={toggleActive} $isSelected={isActive}>
        <StyledMedia onClick={openMedia}>{NormalizeMedia(image)}</StyledMedia>
        <StyledInfosImage>
          <StyledTitle>{titleLevel1}</StyledTitle>
          <StyledSubtitleContainer>
            <StyledButton download href={downloadUrl} variant={ButtonVariantEnum.secondary} target={isContentfulImage ? '_blank' : null}>
              <StyledIcon />
            </StyledButton>
            {titleLevel2 && (<StyledSubtitle>{titleLevel2}</StyledSubtitle>)}
          </StyledSubtitleContainer>
        </StyledInfosImage>
      </StyledCard>
    )
  }


}

export default MediaCard
